module.exports = __webpack_public_path__ + "img/81.57f669dc.png";